var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { of as observableOf } from 'rxjs';
import { map, withLatestFrom, switchMap } from 'rxjs/operators';
import { OrganisationsApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as actions from '../actions/index';
import * as selectors from '../reducers/index';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';
var InviteEffects = /** @class */ (function () {
    function InviteEffects(store, actions$, api, dialog) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.api = api;
        this.dialog = dialog;
        this.sendInvitation = this.actions$
            .ofType(actions.REQUEST_INVITATION_SEND).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], id = _a[1];
            return _this.api
                .invite(id, action.payload)
                .map(function (payload) { return new actions.ResponseSuccessInvitationSendAction(payload); })
                .catch(function (err) { return observableOf(new actions.ResponseFailInvitationSendAction(err)); });
        }));
        this.bulkInvite = this.actions$
            .ofType(actions.Staff.REQUEST_BULK_IMPORT).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], id = _a[1];
            return _this.api
                .importMembers(id, action.payload)
                .map(function (response) { return actions.Staff.ResponseSuccessBulkImport(response); })
                .catch(function (err) { return observableOf(actions.Staff.ResponseFailBulkImport(err)); });
        }));
        this.getPending = this.actions$
            .ofType(actions.REQUEST_INVITATIONS_PENDING).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], id = _a[1];
            return _this.api
                .listPendingInvitations(id)
                .map(function (response) { return new actions.ResponseSuccessPendingInvitations(response); })
                .catch(function (err) { return observableOf(new actions.ResponseFailPendingInvitations(err)); });
        }));
        this.resendInvite = this.actions$
            .ofType(actions.REQUEST_INVITATION_RESEND).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], id = _a[1];
            return _this.api
                .resendInvitation(id, action.payload.id)
                .map(function (payload) { return new actions.ResponseSuccessInvitationResendAction(payload); })
                .catch(function (err) { return observableOf(new actions.ResponseFailInvitationResendAction(err)); });
        }));
        this.cancelInvite = this.actions$
            .ofType(actions.REQUEST_INVITATION_CANCEL).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], id = _a[1];
            return _this.dialog
                .open(ConfirmationDialogComponent, {
                data: {
                    title: 'Cancel Invitation?',
                    body: 'Are you sure you want to cancel this invitation?',
                    confirm: 'Cancel invite',
                    cancel: 'Keep invite',
                    confirmColor: 'warn'
                }
            })
                .afterClosed().pipe(map(function (result) { return [action, id, result]; }));
        }), switchMap(function (_a) {
            var action = _a[0], id = _a[1], result = _a[2];
            return result
                ? _this.api
                    .deleteInvitation(id, action.payload.id)
                    .map(function (payload) {
                    return new actions.ResponseSuccessInvitationCancelAction({ id: action.payload.id });
                })
                    .catch(function (err) { return observableOf(new actions.ResponseFailInvitationCancel(err)); })
                : observableOf({ type: 'CANCELLED' });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], InviteEffects.prototype, "sendInvitation", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], InviteEffects.prototype, "bulkInvite", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], InviteEffects.prototype, "getPending", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], InviteEffects.prototype, "resendInvite", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], InviteEffects.prototype, "cancelInvite", void 0);
    return InviteEffects;
}());
export { InviteEffects };
